import PropTypes from 'prop-types';
import * as React from 'react';

const Rocket = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const DEFAULT_W = 18;
  const DEFAULT_H = 20;
  const width = size ?? DEFAULT_W;
  const height = size ?? DEFAULT_H;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path
        d="M11.1123 10.3983C11.1905 10.7307 11.2319 11.0773 11.2319 11.4336C11.2319 13.9189 9.21722 15.9336 6.73193 15.9336V12.3338M11.1123 10.3983C13.9127 8.35193 15.7319 5.04265 15.7319 1.30859C11.998 1.30875 8.68904 3.12799 6.64285 5.92841M11.1123 10.3983C9.83084 11.3347 8.34397 12.0066 6.73193 12.3338M6.64285 5.92841C6.31026 5.85005 5.96344 5.80859 5.60693 5.80859C3.12165 5.80859 1.10693 7.82331 1.10693 10.3086H4.70748M6.64285 5.92841C5.70657 7.2098 5.03469 8.69662 4.70748 10.3086M6.73193 12.3338C6.65438 12.3496 6.57653 12.3645 6.4984 12.3787C5.81821 11.8393 5.20186 11.223 4.66253 10.5428C4.6767 10.4644 4.69169 10.3864 4.70748 10.3086M3.02837 12.1017C2.20353 12.717 1.66943 13.7004 1.66943 14.8086C1.66943 14.9862 1.68316 15.1607 1.70961 15.3309C1.87984 15.3574 2.05428 15.3711 2.23193 15.3711C3.34012 15.3711 4.32355 14.837 4.93887 14.0122M11.7944 6.37109C11.7944 6.99241 11.2908 7.49609 10.6694 7.49609C10.0481 7.49609 9.54443 6.99241 9.54443 6.37109C9.54443 5.74977 10.0481 5.24609 10.6694 5.24609C11.2908 5.24609 11.7944 5.74977 11.7944 6.37109Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

Rocket.displayName = 'Trash';

Rocket.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Rocket;
